<template src="./Portfolio.html"></template>

<script>
import Form from 'components/form/Form';
import { onWaypoint } from 'src/mixins';
import { mapGetters, mapActions } from 'vuex';
import Preview from './Preview';
import Filters from './Filters';

export default {
  mixins: [onWaypoint],

  components: {
    Form,
    Preview,
    Filters,
  },
  computed: {
    ...mapGetters(['portfolio']),
  },
  mounted() {
    this.updateParallax();
  },
  updated() {
    this.$nextTick(() => {
      this.updateParallax();
    });
  },
  methods: {
    ...mapActions(['clearStoreFilter']),
    updateParallax() {
      import('jarallax').then(({ jarallax, jarallaxElement }) => {
        jarallaxElement(document.querySelectorAll('.jarallax'), 'destroy');
        jarallax(document.querySelectorAll('.jarallax'), 'destroy');
        jarallaxElement(document.querySelectorAll('.jarallax'), {
          speed: 0.2,
        });
        jarallax(document.querySelectorAll('.jarallax'), {
          speed: 0.2,
        });
      });
    },
  },
  destroyed() {
    if (this.$route.name !== 'portfolio_page') {
      this.clearStoreFilter();
    }
  },
};
</script>

<style lang="scss">
@import "~styles/vars.scss";
@import "~styles/portfolio.scss";
</style>



// WEBPACK FOOTER //
// src/components/portfolio/Portfolio.vue